
<select class="lang-selector" :value="currentLang" @input="changeLang($event.target.value)">
  <option v-for="lang in langs" :key="lang.code" :value="lang.code">{{ lang.code }}</option>
</select>
